/**
 * Inject `<script type="application/ld+json">` into the document head.
 *
 * Auto-cleans up on unmount so old schema doesn't bleed between routes.
 * Safe to call with `null`/undefined — no-ops in that case.
 *
 * Why not react-helmet? Adding a 60KB dep for one feature is overkill;
 * the schema we render is a small static object per page.
 */
import { useEffect } from 'react';

export default function useStructuredData(schema, key = 'structured-data') {
  useEffect(() => {
    if (!schema) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-key', key);
    el.textContent = JSON.stringify(schema);

    // Remove any prior tag with the same key (route changes, hot reload)
    document.head
      .querySelectorAll(`script[type="application/ld+json"][data-key="${key}"]`)
      .forEach((n) => n.remove());

    document.head.appendChild(el);
    return () => el.remove();
  }, [schema, key]);
}
